import React from 'react';
import { Card, CardContent } from '../../../ui/card';

interface MetricsCardsProps {
  totalOpenSignals: number;
  totalOpenCases: number;
}

export const MetricsCards: React.FC<MetricsCardsProps> = ({
  totalOpenSignals,
  totalOpenCases
}) => {
  return (
    <Card className="h-[230px] relative">
      <CardContent className="p-0 h-full">
        {/* Total Open Signals Section */}
        <div className="absolute top-[13.043%] left-[8.088%] right-[8.088%] bottom-[61.304%] flex justify-between items-start">
          <div>
            <p className="text-[19.73px] font-bold text-[#262628] leading-normal m-0" style={{ fontFamily: 'Open Sans, sans-serif' }}>
              Total
            </p>
            <p className="text-[19.73px] font-bold text-[#262628] leading-normal m-0" style={{ fontFamily: 'Open Sans, sans-serif' }}>
              open signals
            </p>
          </div>
          <div className="text-[23.67px] font-bold text-[#904EFD] text-right" style={{ fontFamily: 'Open Sans, sans-serif' }}>
            {totalOpenSignals}
          </div>
        </div>

        {/* Divider Line */}
        <div className="absolute top-1/2 left-[8.088%] right-[7.721%] h-[1px] bg-[#E0E0E0]"></div>

        {/* Total Open Cases Section */}
        <div className="absolute top-[59.565%] left-[8.088%] right-[8.088%] bottom-[14.783%] flex justify-between items-start">
          <div>
            <p className="text-[19.73px] font-bold text-[#262628] leading-normal m-0" style={{ fontFamily: 'Open Sans, sans-serif' }}>
              Total
            </p>
            <p className="text-[19.73px] font-bold text-[#262628] leading-normal m-0" style={{ fontFamily: 'Open Sans, sans-serif' }}>
              open cases
            </p>
          </div>
          <div className="text-[23.67px] font-bold text-[#06809C] text-right" style={{ fontFamily: 'Open Sans, sans-serif' }}>
            {totalOpenCases}
          </div>
        </div>

        {/* Percentage Change */}
        <div className="absolute bottom-[10%] right-[8.088%] text-[8.68px] text-[#A5A5A5] text-right" style={{ fontFamily: 'Open Sans, sans-serif' }}>
          +12%
        </div>
      </CardContent>
    </Card>
  );
};